/**
 * Created by Administrador on 07/08/2019.
 */
(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('flightAvailabilityCtrl', flightAvailabilityCtrl);

    flightAvailabilityCtrl.$inject = ['tabs','datePickerService', 'levelOfSaleReservationsService','flightService','linkService','printService'];

    function flightAvailabilityCtrl(tabs,datePickerService, levelOfSaleReservationsService,flightService,linkService,printService) {
        var vm = this;
        vm.tabs = tabs;
        vm.isReport = false;
        vm.reportClassAvailabilityHtml = '';
        vm.datePickerOpenStatus = {
            departureDate: false
        };
        vm.pickerButtons = datePickerService.pickerButtons();

        vm.datepickerDepartureDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: null
            },
            closed: function(args) {
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.filterLevelOfSalesReservations = {
            departureDate : new Date()
        }

        vm.eventFlights = function(){
            vm.report = undefined;
            if(vm.filterLevelOfSalesReservations.departureDate != undefined){
                vm.flights= [];
                flightService.getFlightsFromDate(vm.filterLevelOfSalesReservations.departureDate.getTime())
                    .then(function (response) {
                      var auxFlights = (response.data._embedded) ? response.data._embedded.flights : [];
                        angular.forEach(auxFlights, function(flight){
                            vm.flights.push({
                                flightNumber: flight.flightNumber,
                                flightId: linkService.getLinkId(flight._links.self.href),
                                route: flight._embedded.route.initials
                            });
                        });
                    });
            }
        }

        vm.eventFlights();

        vm.generate = function (isValid) {
            if(isValid) {
                levelOfSaleReservationsService.getLevelOfSaleReservationByFlight(vm.filterLevelOfSalesReservations.flight.flightId)
                    .then(function (response) {
                        vm.reportClassAvailabilityHtml = response.data;
                        vm.isReport = true;
                    });
            }
        }

        vm.generatePdfHtml = function () {
            printService.printPdfHtml("reportClassAvailabilityHtml");
        }

        vm.generatePdf = function () {
            passengerListService.getGeneralReportByFlightPdf(vm.status,vm.filterPassengerList.flight.flightId,vm.filterPassengerList.detail).then(function (response) {
                if(response !== undefined){
                    var filePdf = new Blob([response.data], { type: 'application/pdf'});
                    var nameFile = 'arching-' + (new Date()).getTime() + '.pdf';
                    if (window.navigator && window.navigator.msSaveOrOpenBlob){
                        window.navigator.msSaveBlob(filePdf, nameFile);
                    }else{
                        var fileURL = URL.createObjectURL(filePdf);
                        var a = document.createElement('a');
                        a.href = fileURL;
                        a.target = '_blank';
                        a.download = nameFile;
                        document.body.appendChild(a);
                        a.click();
                    }
                }

            });
        }
    }

})();
